import React, { useState } from 'react';
import { LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import TopMenu from './TopMenu';
import Charts from './Charts';
import Table from './Table';
import { useOktaQuery, PitcherStrengths } from '../../../../data';
import usePlayerSelector from '../../../../utils/usePlayerSelector';
import useConfig from '../../../../utils/useConfig';

const Overview = () => {
    const { t: translate } = useTranslation();
    const player = usePlayerSelector();
    const { CurrentYear } = useConfig();

    const [pitcher, setPitcher] = useState(player.IsCatcher ? null : player);
    const [isLoadingFilters, setIsLoadingFilters] = useState(true);
    const [year, setYear] = useState(null);
    const [level, setLevel] = useState(null);
    const [isLhb, setIsLhb] = useState(null);
    const [role, setRole] = useState(null);
    const [hasSearched, setHasSearched] = useState(!player.IsCatcher);

    let ntileLevelId = null;
    if (level?.value === null) ntileLevelId = 8;
    else if (level?.value === 7) ntileLevelId = player.Team.LevelID;

    const { data: overview, isFetching } = useOktaQuery(
        ['overview', { year: `${year?.value.startYear}-${year?.value.endYear}`,
            pitcherId: pitcher?.PlayerID,
            level: level?.value,
            isLhb: isLhb?.value,
            role: role?.value,
            playerId: player.PlayerID }],
        (t) => PitcherStrengths.getOverview(t, {
            pitcherId: pitcher.PlayerID,
            startYear: year.value.startYear,
            endYear: year.value.endYear,
            level: level.value,
            isLhb: isLhb.value,
            role: role.value,
            currentYear: CurrentYear,
            ntileLevelId,
        }),
        {
            enabled: !!pitcher?.PlayerID && !!year?.value.startYear && !!year?.value.endYear && !!level && !!isLhb && !!role,
            staleTime: Infinity,
        },
    );

    return (
        <div>
            <div className={isLoadingFilters ? '' : 'd-flex justify-content-between align-items-center'}>
                <h3 className="mb-0">{translate('sections.reports.pitcher.overview-title')}</h3>
                <TopMenu
                    setIsLoadingFilters={setIsLoadingFilters}
                    pitcher={pitcher}
                    setPitcher={setPitcher}
                    year={year}
                    setYear={setYear}
                    level={level}
                    setLevel={setLevel}
                    isLhb={isLhb}
                    setIsLhb={setIsLhb}
                    role={role}
                    setRole={setRole}
                    setHasSearched={setHasSearched}
                />
            </div>
            {!hasSearched && <div className="text-center py-4 px-3 mt-3">{translate('sections.reports.pitcher.use-filters')}</div>}
            { !isLoadingFilters && hasSearched && (
                isFetching ? (
                    <div className="d-flex justify-content-center py-5">
                        <LoadingSpinner />
                    </div>
                ) : (
                    <div className="bg-white border rounded py-4 px-3 mt-3">
                        {overview && overview.player.length ? (
                            <>
                                <Charts className="mt-3" overview={overview} />
                                <Table
                                    className="mt-5"
                                    seasonStats={overview.seasonstats}
                                    levelAverage={overview.levelaverage[0]}
                                    level={level}
                                    isisLhbSelected={isLhb?.value !== null}
                                />
                            </>
                        ) : <div className="text-center">{translate('pitcher-overview.no-data')}</div>}
                    </div>
                ))}
        </div>
    );
};

export default Overview;
